import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch } from 'dva';
import { useSelector, useLocation } from 'umi';
import { OPT_DETAIL } from '@/constants';
import DragStyled from './DragStyles';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',

  // styles we need to apply on draggables
  ...draggableStyle,
});

export default ({ setNum, num }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { opt } = query;
  const { goodsShelfList, selectId } = useSelector(
    (state) => state.managementGoodsShelfForm,
  );
  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(
      goodsShelfList,
      result.source.index,
      result.destination.index,
    );

    dispatch({
      type: 'managementGoodsShelfForm/saveName',
      payload: {
        values: {
          items,
          draggableId: result.draggableId,
        },
      },
    });
  };

  const handleClick = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch({
      type: 'managementGoodsShelfForm/isError',
      payload: {
        values: {
          id: selectId ? selectId : goodsShelfList[0].id,
        },
      },
      callback: () => {
        dispatch({
          type: 'managementGoodsShelfForm/saveId',
          payload: {
            values: {
              id,
            },
          },
        });
      },
    });
  };

  const handleAddNameClick = () => {
    dispatch({
      type: 'managementGoodsShelfForm/isError',
      payload: {
        values: {
          id: selectId ? selectId : goodsShelfList[0].id,
        },
      },
      callback: () => {
        dispatch({
          type: 'managementGoodsShelfForm/addName',
        });
      },
    });
  };

  const handleClickDelete = (e, id) => {
    e.stopPropagation();
    e.preventDefault();

    dispatch({
      type: 'managementGoodsShelfForm/deleteGoodsShelf',
      payload: {
        values: {
          id,
        },
      },
      callback: () => {
        setNum(num + 1);
      },
    });
  };

  const sId = selectId ? selectId : goodsShelfList[0].id;
  return (
    <DragStyled>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable" direction="horizontal">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                overflowX: 'auto',
                overflowY: 'hidden',
              }}
            >
              {goodsShelfList.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided1, snapshot1) => (
                    <div
                      ref={provided1.innerRef}
                      {...provided1.draggableProps}
                      {...provided1.dragHandleProps}
                      style={{
                        display: 'flex',
                        flexShrink: 0,
                        ...getItemStyle(
                          snapshot1.isDragging,
                          provided1.draggableProps.style,
                        ),
                      }}
                    >
                      <div
                        className={
                          sId === item.id
                            ? 'goods-shelf-name goods-shelf-name-choose'
                            : 'goods-shelf-name'
                        }
                        onClick={(e) => handleClick(e, item.id)}
                      >
                        {item.goodsShelfName}{' '}
                        {opt !== OPT_DETAIL && (
                          <span
                            className={
                              sId === item.id
                                ? 'goods-shelf-name-delete goods-shelf-name-choose-delete'
                                : 'goods-shelf-name-delete'
                            }
                            onClick={(e) => handleClickDelete(e, item.id)}
                          >
                            x
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
              {opt !== OPT_DETAIL && (
                <div className="add-button" onClick={handleAddNameClick}>
                  <AddIcon sx={{ width: '14px', height: '14px' }} />
                  添加子货架
                </div>
              )}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </DragStyled>
  );
};
